import React, {Fragment} from 'react'
import styles from '../LeaderBoard/LeaderBoard.module.sass'
import {defaultScan} from "../../../config"
import {humanLongTime, shortAddress} from "../../../core/helpers"
import {ReactComponent as Icon} from './icon.svg'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

export function Transactions({ transactions }) {
    // console.log('%cTransactions.js line:10 transactions', 'color: #007acc;', transactions);
    return (
        <div className={styles.wrap}>
            <img src="images/cnr-logo.jpg" className={styles.icon} alt="logo cnr" />
            {/*<Icon className={styles.icon} />*/}
            <div className={styles.header}>
                <div className={styles.top}>Blockchain Transactions</div>
            </div>
            <div className={styles.overflow}>
            <Table>
                <Thead className={styles.tb_th}>
                    <Tr className={styles.tr}>
                        <Th>Time</Th>
                        <Th>Address</Th>
                        <Th>Amount</Th>
                    </Tr>
                </Thead>
                <Tbody className={styles.tbody}>
                    {transactions?.map((i, it) => {
                        return (
                            <Tr className={styles.tr} key={i.address + it + i.time}>
                                <Td>
                                    <a href={`${defaultScan}/tx/${i.txh}`} className={styles.td_link_time} target="_blank" rel="noreferrer">
                                        {humanLongTime(i.time)}
                                    </a>
                                </Td>
                                <Td>
                                    <a
                                        href={`${defaultScan}/address/${i.address}`}
                                        className={styles.td_link}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {i.address}
                                    </a>
                                    <a
                                        href={`${defaultScan}/address/${i.address}`}
                                        className={styles.td_link_short}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {shortAddress(i.address)}
                                    </a>
                                </Td>
                                <Td className={styles.td_amount}>{`${i.sign}${i.amount}`}</Td>
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
            </div>
        </div>
    )
}
